import { Cross, LeftArrow } from "@monsterindia/global-ui-components";
import React from "react";

type HeadingProps = {
  headingText: string;
  isMobile?: boolean;
  onBackBtnClickHandler?: () => void;
  onCloseBtnClickHandler?: () => void;
  className?: string;
};

export const Heading = ({
  headingText,
  className,
  isMobile = false,
  onBackBtnClickHandler,
  onCloseBtnClickHandler,
}: HeadingProps) => {
  return (
    <div
      className={`l1-fixed l1-left-0 l1-top-0 l1-z-10 l1-flex l1-w-full l1-items-center l1-gap-1 l1-border-b l1-border-border-moderate l1-bg-white l1-px-4 l1-py-3 md:!l1-px-8 md:l1-py-4 ${className ?? ""}`}
      id="l1ApopHeading"
    >
      {onBackBtnClickHandler ? (
        <button
          onClick={onBackBtnClickHandler}
          className="-l1-ml-2 l1-cursor-pointer"
          type="button"
        >
          <LeftArrow
            width={24}
            height={20}
            className="l1-fill-content-primary"
          />
        </button>
      ) : null}

      <h3 className="l1-w-max l1-text-sm l1-font-bold l1-text-content-primary !l1-py-1 md:!l1-text-base">
        {headingText}
      </h3>

      {isMobile && onCloseBtnClickHandler ? (
        <button
          onClick={onCloseBtnClickHandler}
          className="l1-ml-auto"
          type="button"
        >
          <Cross width={24} height={24} className="l1-fill-content-primary" />
        </button>
      ) : null}
    </div>
  );
};
